import {api} from "../../src/api";
import {Notifications} from "../../src/notifications";
import {FreezeUI} from "../../src/freeze-ui";
import {Sortable} from '@shopify/draggable';

document.addEventListener("DOMContentLoaded", () => {
    if(typeof Sortable === "undefined")
        return;

    const passes = document.querySelector("#passes");
    if(!passes)
        return;

    const sortable = new Sortable(document.querySelector("#passes"), {
        draggable: "[data-pass-id]",
        handle: "[data-pass-id] .handle",
        mirror: {
            appendTo: "body",
            constrainDimensions: true
        }
    });

    sortable.on("sortable:stop", async (e) => {
        try{
            FreezeUI.Freeze();
            await api.post("?Handler=SetOrder", {
                id: e.data.dragEvent.data.originalSource.dataset.passId,
                newIndex: e.data.newIndex,
                oldIndex: e.data.oldIndex
            });

            Notifications.showSuccess({ message: "Saved!" });
        }
        catch(err){
            console.error(err);
            Notifications.showError({ message: "There was a problem saving the new order. Please try again later." })
        }
        finally{
            FreezeUI.UnFreeze();
        }
    });
});
